import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges Tailwind CSS classes efficiently without style conflicts.
 * Essential for shadcn/ui and custom dynamic components.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}